<div class="p-6 md:p-8">
      <!-- Conditional rendering for each tab component with smooth animations -->
      <div [@contentAnimation] class="tab-content-wrapper">
            <app-overview *ngIf="isActiveTab('overview')" [@tabAnimation] class="tab-content"></app-overview>
            <app-crm-dashboard *ngIf="isActiveTab('crm-dashboard')" [@tabAnimation]
                  class="tab-content"></app-crm-dashboard>
            <app-calendar *ngIf="isActiveTab('calendar')" [@tabAnimation] class="tab-content"></app-calendar>
            <app-marketing *ngIf="isActiveTab('marketing')" [@tabAnimation] class="tab-content"></app-marketing>
            <app-commissions *ngIf="isActiveTab('commissions')" [@tabAnimation] class="tab-content"></app-commissions>
            <app-projects *ngIf="isActiveTab('projects')" [@tabAnimation] class="tab-content"></app-projects>
            <app-units *ngIf="isActiveTab('units')" [@tabAnimation] class="tab-content"></app-units>
            <app-offers *ngIf="isActiveTab('offers')" [@tabAnimation] class="tab-content"></app-offers>
            <app-settings *ngIf="isActiveTab('settings')" [@tabAnimation] class="tab-content"></app-settings>
            <app-profile *ngIf="isActiveTab('profile')" [@tabAnimation] class="tab-content"></app-profile>
            <app-staff-dashboard *ngIf="isActiveTab('staff')" [@tabAnimation] class="tab-content"></app-staff-dashboard>
      </div>
</div>
